import { RouterChild } from '@/router';

export default [
  {
    name: 'admin-scope-of-functions',
    path: 'scope-of-functions',
    component: () => import('./views/Overview.vue')
  } as RouterChild
];
